// JS imports -------------------------------
import './listing-globals/bootstrap';
import './listing-globals/global';
import './global/cookie_manage';
import './listing-globals/initialize_topics';

import '../../node_modules/jquery-validation/dist/jquery.validate';
import './listing-forms/jquery.validate.configuration';
import './listing-utils/jquery.serializejson';
import './listing-utils/utils';
import './listing-utils/vueApp';
import './listing-utils/modal';

import './listing-forms/input_autocomplete';
import './listing-forms/input_geo_nav';
import './listing-forms/input_sev_nav';

import './listing-seo/seoLink';
import './listing-seo/ga';
import './listing-seo/trafficsourcecontrol';

import './listing-request/storage';
import './listing-request/country_page_suggest';
import './listing-request/extended_form';
import './listing-request/front_request';

import './listing-schedule/listing_appointment';
import './listing-page/listings';
import './listing-page/main_header';

import './listing-filters/listing_header';
import './listing-filters/listing_filters';

import './iempresas/common/footer';

import intlTelInput from './listing-forms/intlTelInput';
window.intlTelInput = intlTelInput;

import Vue from 'vue/dist/vue.js';
Vue.config.productionTip = false;
Vue.config.devtools = false
















